module.exports = __webpack_public_path__ + "static/media/jungwoo-asap.139f635c.mp3";